export default "/images/uni_bank.png?9a042fde4be12afc78ae123eb1ec263b";